module.exports = __webpack_public_path__ + "static/img/empty_trading_container.36c3b541.png";